export const SIZES = {
  mobile: "481px",
  tablet: "769px",
  laptop: "1025px",
  desktop: "1201px",
  desktopL: "1441px",
};
